import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconLbiBrandGradient = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 279 257"
    aria-label="IconLbiBrandGradient"
    ref={ref}
    {...props}
  >
    <path
      stroke="url(#IconLbiBrandGradient__a)"
      strokeOpacity={0.2}
      strokeWidth={6}
      d="m205.913 3 .555.01a16.84 16.84 0 0 1 7.888 2.287 16.96 16.96 0 0 1 6.176 6.238l.001.001 54.486 95.277a7.36 7.36 0 0 1 .001 7.299 7.3 7.3 0 0 1-2.643 2.674 7.2 7.2 0 0 1-3.607.992H157.082a12.13 12.13 0 0 1-6.087-1.659 12.23 12.23 0 0 1-4.452-4.502l-.002-.002-40.991-71.732h.001a8.15 8.15 0 0 0-4.951-3.863 8.1 8.1 0 0 0-5.871.634l-.346.19-4.36 2.535-.02.012a8.24 8.24 0 0 0-3.764 4.97 8.27 8.27 0 0 0 .783 6.186l.01.018 41.013 71.748.006.011a12.35 12.35 0 0 1 0 12.34l-.006.011-41.013 71.773-.005.008-.005.009a8.27 8.27 0 0 0-.783 6.185 8.24 8.24 0 0 0 3.765 4.971l.01.006.01.005 4.359 2.535.008.005.007.004a8.15 8.15 0 0 0 6.196.796 8.18 8.18 0 0 0 4.733-3.474l.21-.346.003-.006 41.013-71.749.006-.01a12.14 12.14 0 0 1 4.441-4.505 12.06 12.06 0 0 1 6.084-1.649h111.697l.238.005a7.2 7.2 0 0 1 3.37.988 7.3 7.3 0 0 1 2.642 2.673 7.35 7.35 0 0 1-.001 7.3l-54.497 95.265-.004.007a16.9 16.9 0 0 1-6.168 6.241 16.77 16.77 0 0 1-8.442 2.288h-124a16.77 16.77 0 0 1-8.441-2.288 16.9 16.9 0 0 1-6.168-6.241l-.004-.007L5.287 137.057l-.005-.008a17.12 17.12 0 0 1 0-17.086l.004-.008L67.317 11.536l.004-.007a16.9 16.9 0 0 1 6.163-6.239 16.8 16.8 0 0 1 7.882-2.28l.556-.01z"
    />
    <path
      stroke="url(#IconLbiBrandGradient__b)"
      strokeWidth={6}
      d="m205.913 3 .555.01a16.84 16.84 0 0 1 7.888 2.287 16.96 16.96 0 0 1 6.176 6.238l.001.001 54.486 95.277a7.36 7.36 0 0 1 .001 7.299 7.3 7.3 0 0 1-2.643 2.674 7.2 7.2 0 0 1-3.607.992H157.082a12.13 12.13 0 0 1-6.087-1.659 12.23 12.23 0 0 1-4.452-4.502l-.002-.002-40.991-71.732h.001a8.15 8.15 0 0 0-4.951-3.863 8.1 8.1 0 0 0-5.871.634l-.346.19-4.36 2.535-.02.012a8.24 8.24 0 0 0-3.764 4.97 8.27 8.27 0 0 0 .783 6.186l.01.018 41.013 71.748.006.011a12.35 12.35 0 0 1 0 12.34l-.006.011-41.013 71.773-.005.008-.005.009a8.27 8.27 0 0 0-.783 6.185 8.24 8.24 0 0 0 3.765 4.971l.01.006.01.005 4.359 2.535.008.005.007.004a8.15 8.15 0 0 0 6.196.796 8.18 8.18 0 0 0 4.733-3.474l.21-.346.003-.006 41.013-71.749.006-.01a12.14 12.14 0 0 1 4.441-4.505 12.06 12.06 0 0 1 6.084-1.649h111.697l.238.005a7.2 7.2 0 0 1 3.37.988 7.3 7.3 0 0 1 2.642 2.673 7.35 7.35 0 0 1-.001 7.3l-54.497 95.265-.004.007a16.9 16.9 0 0 1-6.168 6.241 16.77 16.77 0 0 1-8.442 2.288h-124a16.77 16.77 0 0 1-8.441-2.288 16.9 16.9 0 0 1-6.168-6.241l-.004-.007L5.287 137.057l-.005-.008a17.12 17.12 0 0 1 0-17.086l.004-.008L67.317 11.536l.004-.007a16.9 16.9 0 0 1 6.163-6.239 16.8 16.8 0 0 1 7.882-2.28l.556-.01z"
    />
    <defs>
      <linearGradient
        id="IconLbiBrandGradient__a"
        x1={279}
        x2={19.951}
        y1={242.608}
        y2={-2.339}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#16A34A" />
        <stop offset={1} stopColor="#BED000" />
      </linearGradient>
      <linearGradient
        id="IconLbiBrandGradient__b"
        x1={139.5}
        x2={139.5}
        y1={0}
        y2={257}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={0.5} stopColor="#fff" stopOpacity={0.7} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
    </defs>
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconLbiBrandGradient);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
